exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7511f826] .el-table th {\n  padding: 2px 0;\n}\n[data-v-7511f826] .el-table th.el-table__cell {\n  overflow: hidden;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: #FFF;\n}\n[data-v-7511f826] .el-table__footer-wrapper tbody td.el-table__cell, .el-table__header-wrapper tbody td.el-table__cell[data-v-7511f826] {\n  font-weight: bold;\n  background-color: #F5F7FA;\n  color: #0957f4;\n}\n", ""]);

// exports
